import React, { useState, useEffect } from "react";
import { HiCheck } from "react-icons/hi";

export default function CheckItem({ callBack }) {
  const [isCheck, setIsCheck] = useState(false);

  return (
    <div
      className="box-one-check-box-by-nile"
    >
      <div
        id={isCheck ? "one-check-box-has-checked" : ""}
        className="one-check-box-checked-by-nile"
        onClick={() => {
          callBack(!isCheck);
          setIsCheck(!isCheck);
        }}
      >
        <HiCheck color="white" size={"0.7rem"} />
      </div>
    </div>
  );
}

// import React, { useState } from "react";
// import { HiCheck } from "react-icons/hi";
// export default function CheckItem({ callBack }) {
//   const [isCheck, setIsCheck] = useState(false);

//   return (
//     <div
//       className="box-one-check-box"
//       onClick={() => {
//         callBack(isCheck);
//         setIsCheck(!isCheck);
//       }}
//     >
//       <div
//         id={isCheck ? "one-check-box-has-checked" : ""}
//         className="one-check-box-checked"
//       >
//         <HiCheck color="white" size={"0.7rem"} />
//       </div>
//     </div>
//   );
// }
